import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Page from 'components/Page';
import AppHeader from 'components/AppHeader';
import Loader from 'components/Loader';
import './styles.scss';

export default function Quiz() {
    const [quote, setQuote] = useState(null);
    const [score, setScore] = useState(0);
    const [inputValue, setInputValue] = useState('')
    const [loading, setLoading] = useState(true);
    const [hint, setHint] = useState(null);
    const [isCorrect, setIsCorrect] = useState(null);
    const [isOver, setIsOver] = useState(false);
    const [showInput, setShowInput] = useState(true);
    const [gotHint, setGotHint] = useState(false)

    const handleHelpBtn = function (event) {
        event.preventDefault();
        setGotHint(true);
        setScore(score - 3)
        const options = {
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/hint`,
        };
        axios.request(options).then(function (response) {
            setHint(response.data.shuffledHint);

        }).catch(function (error) {
            console.error(error);
        });
    }

    const handleFormSubmit = function (event) {
        event.preventDefault();
        if (inputValue.length < 2 || inputValue.length > 20) {
            window.alert("Réponse non valide")
            return
        }
        setShowInput(false)
        setLoading(true)
        const options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/game`,
            headers: { 'Content-Type': 'application/json' },
            data: { answer: inputValue }
        };
        axios.defaults.withCredentials = true;
        axios.request(options).then(function (response) {
            const { isOver, quote, score, correctAnswer, isCorrect } = response.data;
            setLoading(false)
            setInputValue('');
            setScore(score);
            setHint(null);
            setQuote(correctAnswer);
            setTimeout(() => {
                setQuote(quote);
                setIsCorrect(null);
                if (!isOver) {
                    setShowInput(true);
                }
                setGotHint(false);
            }, 2000);

            if (isCorrect) {
                setIsCorrect('correct')
            } else {
                setIsCorrect('incorrect')
            }

            if (isOver) {
                setTimeout(() => {
                    setIsOver(true)

                }, 2000);
                setShowInput(false)
            }

        }).catch(function (error) {
            console.error(error);
        });
    }

    const handleOnChange = (event) => {
        setInputValue(event.target.value);
    };
    const handleHintSubmit = (evt) => {
        evt.preventDefault();
        setShowInput(false)
        setLoading(true)
        const options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/game`,
            headers: { 'Content-Type': 'application/json' },
            data: { answer: evt.target.textContent }
        };
        axios.defaults.withCredentials = true;
        axios.request(options).then(function (response) {
            const { isOver, quote, score, correctAnswer, isCorrect } = response.data;
            setLoading(false)
            setInputValue('');
            setScore(score);
            setHint(null);
            setQuote(correctAnswer);
            setTimeout(() => {
                setQuote(quote);
                setIsCorrect(null);
                if (!isOver) {
                    setShowInput(true);
                }
                setGotHint(false);
            }, 2000);

            if (isCorrect) {
                setIsCorrect('correct')
            } else {
                setIsCorrect('incorrect')
            }

            if (isOver) {
                setTimeout(() => {
                    setIsOver(true)

                }, 2000);
                setShowInput(false)
            }

        }).catch(function (error) {
            console.error(error);
        });
    }

    useEffect(() => {
        const options = {
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/game`,
            headers: { 'Content-Type': 'application/json' }
        };
        axios.defaults.withCredentials = true
        axios.request(options).then(function (response) {
            // if (response.status === 200) {
            setQuote(response.data);
            setLoading(false);
            // }
        }).catch(function (error) {
            console.error(error);
        });
    }, [])

    return (
        <>
            <AppHeader />
            <Page>
                <div className={`content content--${isCorrect}`}>
                    {!loading ?
                        (
                            <>
                                <div className="scoreBox">
                                    <p className='score_text'>Score</p>
                                    <p className='score'>{score}</p>
                                </div>
                                <p className='quote' dangerouslySetInnerHTML={{ __html: quote }}></p>
                                {showInput ? (<form className='gameForm' action="#" onSubmit={handleFormSubmit}>
                                    {!gotHint && (
                                        <input type="text" name="res" id="response" autoComplete="off" minLength="2" maxLength="20" autoFocus value={inputValue}
                                            onChange={handleOnChange} />
                                    )}
                                    <div className="form_buttons">
                                        {!gotHint && (
                                            <>
                                                <input className='button' type="submit" value="Valider" />
                                                <input className='button button_help' type='button' value="Aide" onClick={(e) => handleHelpBtn(e)} />
                                            </>
                                        )}
                                    </div>
                                </form>) : null}

                                {hint && (
                                    <ul className="hintList">
                                        {(hint.map((auth) => (
                                            <li key={auth.id} className='button button_help' onClick={handleHintSubmit}>{auth.name}</li>
                                        )))}
                                    </ul>
                                )
                                }
                                {isOver && (
                                    <Navigate to="/fin" replace={true} />
                                )}
                            </>
                        )
                        :
                        (
                            <Loader />
                        )
                    }
                </div>
            </Page>
        </>
    )
}
